import { useRouter } from 'next/router';
import { useMemo } from 'react';

export default function useQueryStringParams(): Record<string, string> {
  const { query } = useRouter();

  return useMemo(
    () =>
      Object.entries(query).reduce<Record<string, string>>((acc, [key, value]) => {
        const stringValue = Array.isArray(value) ? value[0] : value;
        if (typeof stringValue === 'string') {
          acc[key] = stringValue;
        }
        return acc;
      }, {}),
    [query],
  );
}
